export default "__VITE_ASSET__f04634e8__"